var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{staticClass:"text-xs-center",attrs:{"bottom":"","color":"white"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('i',_vm._g({staticClass:"mb-2"},on),[_vm._t("default")],2)]}}],null,true)},[_c('span',{staticClass:"black--text text-xs-center d-block"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }